import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { authService } from "../services/authService";

function PrivateRoute({ children }) {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("token");
      const subscriptionStatus = localStorage.getItem("subscriptionStatus");

      if (!token) {
        setIsAuthorized(false);
        setIsChecking(false);
        return;
      }

      if (subscriptionStatus !== 'active') {
        authService.logout();
        setIsAuthorized(false);
        setIsChecking(false);
        return;
      }

      const result = await authService.checkSubscriptionStatus();
      setIsAuthorized(result.isActive);
      setIsChecking(false);
    };

    checkAuth();
  }, []);

  if (isChecking) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Verificando...</span>
        </div>
      </div>
    );
  }

  if (!isAuthorized) {
    return <Navigate to="/assinar" />;
  }

  return children;
}

export default PrivateRoute;
